import {
  ApiBlueprint,
  createApiFactory,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import {
  catalogApiRef,
  entityPresentationApiRef,
} from '@backstage/plugin-catalog-react';
import { DefaultEntityPresentationApi } from '@backstage/plugin-catalog';
import { ResilientEntityPresentationApi } from '../../lib/ResilientEntityPresentationApi';

// Guards against an upstream crash: @backstage/plugin-org's OwnershipCard
// puts the *humanized* owner name (not a qualified ref) into the Catalog
// page's ?filters[owners]= link, and @backstage/plugin-catalog-react's
// EntityOwnerPicker round-trips that bare string into this API with no
// default-kind context, hitting an unguarded parseEntityRef inside
// @backstage/plugin-catalog's DefaultEntityPresentationApi. Reproduces for
// every team, regardless of how that team's own catalog-info.yaml spells
// its owner field. See ResilientEntityPresentationApi for the full trace.
export function createEntityPresentationApi({
  catalogApi,
}: {
  catalogApi: typeof catalogApiRef.T;
}) {
  return new ResilientEntityPresentationApi(
    DefaultEntityPresentationApi.create({ catalogApi }),
  );
}

// The extension name deliberately mirrors convertLegacyPlugin's id for this API
// (api:catalog/plugin.catalog.entity-presentation), so this module replaces the converted plugin's own
// extension instead of conflicting with it. Pinned by index.test.ts.
export const catalogModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    ApiBlueprint.make({
      name: 'plugin.catalog.entity-presentation',
      params: defineParams =>
        defineParams(
          createApiFactory({
            api: entityPresentationApiRef,
            deps: { catalogApi: catalogApiRef },
            factory: createEntityPresentationApi,
          }),
        ),
    }),
  ],
});
